module.exports = __webpack_public_path__ + "static/img/组 73(2).967213ca.png";